(function () {
  function init(root) {
    if (!root || root.dataset.gdReady) return;
    root.dataset.gdReady = '1';

    var form = root.querySelector('[data-gd-form]');
    var idInput = root.querySelector('[data-gd-variant]');
    var atc = root.querySelector('[data-gd-atc]');
    var priceEl = root.querySelector('[data-gd-price]');
    var giftEl = root.querySelector('[data-gd-gift]');
    var saveWrap = root.querySelector('[data-gd-save-wrap]');
    var saveEl = root.querySelector('[data-gd-save]');
    var barEl = root.querySelector('[data-gd-bar]');
    var errEl = root.querySelector('[data-gd-error]');
    var bundles = root.querySelectorAll('[data-gd-bundle]');

    /* ---- Bundle picker ---- */
    bundles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        bundles.forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
        idInput.value = btn.dataset.variantId;
        if (priceEl) priceEl.textContent = btn.dataset.price;
        if (giftEl) giftEl.textContent = btn.dataset.gift;
        if (saveWrap) {
          saveWrap.hidden = !btn.dataset.save;
          if (saveEl) saveEl.textContent = btn.dataset.save;
        }
        if (barEl) barEl.textContent = btn.dataset.label;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', btn.dataset.variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      });
      btn.addEventListener('keydown', function (e) {
        var list = Array.prototype.filter.call(bundles, function (b) { return !b.disabled; });
        var i = list.indexOf(btn);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); var n = list[(i + 1) % list.length]; n.focus(); n.click(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); var p = list[(i - 1 + list.length) % list.length]; p.focus(); p.click(); }
      });
    });

    /* ---- Gallery thumbs: swap with hero ---- */
    var heroImg = root.querySelector('[data-gd-hero] img');
    root.querySelectorAll('[data-gd-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.querySelector('img');
        if (!heroImg || !img) return;
        var hSrc = heroImg.currentSrc || heroImg.src, hAlt = heroImg.alt;
        heroImg.removeAttribute('srcset');
        heroImg.src = t.dataset.full || img.src;
        heroImg.alt = img.alt;
        img.removeAttribute('srcset');
        img.src = hSrc; img.alt = hAlt;
        t.dataset.full = hSrc;
      });
    });

    /* ---- Add to cart ---- */
    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function horizonAdd(Ev, fd) {
      // Horizon / standard-events themes: let the theme's cart drawer + cart icon react.
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
      if (ids.length) fd.append('sections', ids.join(','));
      var deferred = Ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new Ev.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(fd.get('id')), quantity: 1 }],
        promise: deferred.promise
      }));
      var refresh = function () { return fetch(root_url + 'cart.json').then(function (r) { return r.json(); }); };
      return fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var didError = !!res.status;
          if (didError) showError(res.description || res.message || 'Could not add to cart.');
          return refresh().then(function (cart) {
            deferred.resolve({
              cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'product-form-component', sourceId: form.id, itemCount: 1, productId: root.dataset.productId, sections: res.sections, didError: didError }
            });
          });
        })
        .catch(function (err) { deferred.reject(err); throw err; });
    }

    function legacyAdd(fd) {
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      if (canRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      return fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showError(res.description || res.message || 'Could not add to cart.'); return; }
          if (canRender && res.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(res);
            if (window.publish && window.PUB_SUB_EVENTS) {
              try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ghost-pdp', productVariantId: idInput.value, cartData: res }); } catch (err) {}
            }
          } else {
            window.location.href = root_url + 'cart';
          }
        });
    }

    var eventsLib = null;
    if (document.querySelector('cart-items-component')) {
      eventsLib = import('@shopify/events').catch(function () { return null; });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (root.dataset.afterAdd === 'cart') return; // native POST to /cart/add → cart page
        e.preventDefault();
        if (atc.getAttribute('aria-busy') === 'true') return;
        atc.setAttribute('aria-busy', 'true');
        showError('');
        var fd = new FormData(form);
        Promise.resolve(eventsLib)
          .then(function (Ev) { return Ev && Ev.CartLinesUpdateEvent ? horizonAdd(Ev, fd) : legacyAdd(fd); })
          .catch(function () { form.submit(); })
          .finally(function () { atc.removeAttribute('aria-busy'); });
      });
    }

    /* ---- Sticky bar ---- */
    var sticky = root.querySelector('[data-gd-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-gd-sticky-add]');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    /* ---- Countdown ---- */
    var urg = root.querySelector('[data-gd-urgency]');
    if (urg) {
      var parts = (urg.dataset.deadline || '').split('-').map(Number);
      if (parts.length === 3 && parts[0]) {
        var deadline = new Date(parts[0], parts[1] - 1, parts[2]).getTime();
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
        var dEl = urg.querySelector('[data-gd-d]'), hEl = urg.querySelector('[data-gd-h]'), mEl = urg.querySelector('[data-gd-m]'), sEl = urg.querySelector('[data-gd-s]');
        var arr = urg.querySelector('[data-gd-arrive]');
        var min = +urg.dataset.arriveMin || 4, max = +urg.dataset.arriveMax || 10;
        var tick = function () {
          var now = Date.now(), diff = deadline - now;
          if (diff <= 0) { urg.hidden = true; clearInterval(timer); return; }
          urg.hidden = false;
          dEl.textContent = pad(Math.floor(diff / 864e5));
          hEl.textContent = pad(Math.floor(diff / 36e5) % 24);
          mEl.textContent = pad(Math.floor(diff / 6e4) % 60);
          sEl.textContent = pad(Math.floor(diff / 1e3) % 60);
          if (arr) arr.textContent = fmt(new Date(now + min * 864e5)) + ' – ' + fmt(new Date(now + max * 864e5));
        };
        var timer = setInterval(tick, 1000);
        tick();
      }
    }
  }

  function boot() { document.querySelectorAll('.gd-main').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.gd-main'); if (r) init(r); });
})();
